<template>
  <!-- В режиме редактирования -->
  <div v-if="params.cellStartedEdit" class="d-flex align-center justify-center">
    <v-checkbox v-model="value" />
  </div>
  <!-- В режиме просмотра -->
  <div v-else style="width: 100%; text-align: center">
    <v-icon v-if="params.value === true">mdi mdi-checkbox-marked</v-icon>
    <v-icon v-else-if="params.value === false">mdi mdi-checkbox-blank-outline</v-icon>
  </div>
</template>

<script>
  export default {
    name: 'CheckboxCellRenderer',

    data() {
      return {
        value: null
      }
    },

    created() {
      this.getInitialValue()
    },

    methods: {
      getInitialValue() {
        try {
          let parseValue = JSON.parse(this.params.value)
          if (typeof parseValue !== 'boolean') {
            this.value = false
          }
        } catch (error) {
          /* eslint-disable-next-line */
          console.log('Неверный тип данных для чекбокса', error)
          this.value = false
        }
      },
      // Метод который после редактирвоания обновит наш value
      getValue() {
        return this.value
      }
    }
  }
</script>
